enum addreses {
    //=== Admin User
    adminUserFilter = "/AdminUser/Filter",
    adminUserDelete = "/AdminUser/Delete",
    adminUserUpdate = "/AdminUser/Update",
    adminUserChangeState = "/AdminUser/ChangeState",
    adminUserVerify = "/AdminUser/Verify",
    //=== Admin Terminal
    adminTerminalChangeState = "/AdminTerminal/ChangeState",
    adminTerminalFilter = "/AdminTerminal/Filter",
    adminTerminalAdd = "/AdminTerminal/Add",
    adminTerminalFind = "/AdminTerminal/Find",
    //=== Admin Merchant
    adminMerchantFilter = "/AdminMerchant/Filter",
    adminMerchantDropDown = "/AdminMerchant/FilterDropdown",
    adminMerchantJoin = "/AdminMerchant/Join",
    adminMerchantCreate = "/AdminMerchant/Create",
    //=== Admin Gateway
    adminGatewayFilter = "/AdminGateway/Filter",
    adminGatewayDropdown = "/AdminGateway/FilterDropdown",
    //=== Admin Bank Account
    adminBankAccountDropdown = "/AdminBankAccount/FilterDropdown",
    //=== Admin General
    adminGeneralBehPardakhtExceptions = "/AdminGeneral/BehPardakhtExceptionList",
    //=== Authenticate
    login = "/Authenticate/login",
    register = "/Authenticate/Register",
    refreshToken = "/Authenticate/RefreshToken",
    verifyLogin = "/Authenticate/VerifyLogin",
    verifyRegister = "/Authenticate/VerifyRegister",
    resendVerifyCode = "/Authenticate/ResendCode",
    recoverPassword = "/Authenticate/RecoverPassword",
    //=== User
    refreshUser = "/User/IsAuthenticate",
    updateProfile = "/User/UpdateProfile",
    updatePassword = "/User/UpdatePassword",
    profile = "/User/Profile",
    logout = "/User/logout",
    //== Document
    documentFilter = "/Document/Filter",
    documentFind = "/Document/Find",
    documentDelete = "/Document/Delete",
    documentAdd = "/Document/Add",
    //=== Token
    tokenFilter = "/Token/Filter",
    tokenChangeState = "/Token/ChangeState",
    tokenDelete = "/Token/Delete",
    tokenAdd = "/Token/Add",
    //=== Bank Account
    bankAccountFilter = "/BankAccount/Filter",
    bankAccountFind = "/BankAccount/Find",
    bankAccountDelete = "/BankAccount/Delete",
    bankAccountAdd = "/BankAccount/Add",
    bankAccountUpdate = "/BankAccount/Update",
    //=== Dashboard
    dashboardTransactionStatistics = "/Dashboard/TransactionStatistics",
    dashboardTransactionChart = "/Dashboard/TransactionChart",
    //=== Po Dashboard
    poDashboardTransactionStatistics = "/Dashboard/PoTransactionStatistics",
    poDashboardTransactionChart = "/Dashboard/PoTransactionChart",
    // Attachment
    attachmrntAdd = "/Attachment/Add",
    attachmentDelete = "/Attachment/Delete",
    attachmentFind = "/Attachment/Find",
    //=== Application
    poApplicationDropDown = "/Application/PoFilterDropdown",
    //=== Po Application
    applicationDropDown = "/Application/FilterDropdown",
    //=== Terminal
    terminalDropDown = "/Terminal/FilterDropdown",
    //=== Payment Report
    reportPayment = "/Report/Payment",
    reportDownloadPayment = "/Report/DownloadPayment",
    reportPaymentAggregation = "/Report/PaymentAggregation",
    reportDownloadPaymentAggregation = "/Report/DownloadPaymentAggregation",
    //=== Po Payment Report
    poReportPayment = "/Report/PoPayment",
    poReportDownloadPayment = "/Report/PoDownloadPayment",
    poReportPaymentAggregation = "/Report/PoPaymentAggregation",
    poReportDownloadPaymentAggregation = "/Report/PoDownloadPaymentAggregation",
    //=== Trans Report
    reportTransaction = "/Report/Transaction",
    reportTransactionAggregation = "/Report/TransactionAggregation",
    reportDownloadTransaction = "/Report/DownloadTransaction",
    reportDownloadTransactionAggregation = "/Report/DownloadTransactionAggregation",
    //=== Po Transaction
    poReportTransaction = "/Report/PoTransaction",
    poReportTransactionAggregation = "/Report/PoTransactionAggregation",
    poReportDownloadTransaction = "/Report/PoDownloadTransaction",
    poReportDownloadTransactionAggregation = "/Report/PoDownloadTransactionAggregation",
    //=== Merchant
    merchantDropDown = "/Merchant/FilterDropdown",
    //=== Gateway
    gatewayDropDown = "/Gateway/FilterDropdown",
    //=== TrackerFilter
    trackerFilter = "/Tracker/Filter",
    //=== payment
    createSimplePaymentLink = "/Payment/CreateSimpleLink",
    createComplexPaymentLink = "/Payment/CreateComplexLink",
    searchPaymentById="/Payment/Search"

}
export default addreses;